module.exports = __webpack_public_path__ + "static/media/forklift.503f6957.svg";